import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { groupsApi } from '../services/api';

/**
 * Handles /groups/join-invite?token=xxx from admin invite email.
 * Calls API to join as admin, then redirects to Groups.
 */
const GroupJoinInvite: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Invalid invite link');
      return;
    }
    if (!isAuthenticated) {
      navigate(`/login?redirect=${encodeURIComponent('/groups/join-invite?token=' + token)}`);
      return;
    }

    groupsApi.joinByInvite(token).then((res: any) => {
      if (res?.success) {
        setStatus('success');
        setMessage(`Joined ${res.data?.groupName || 'group'} as ${res.data?.role || 'admin'}!`);
        setTimeout(() => navigate('/groups'), 2000);
      } else {
        setStatus('error');
        setMessage(res?.error || 'Failed to join');
      }
    }).catch(() => {
      setStatus('error');
      setMessage('Failed to join');
    });
  }, [searchParams, isAuthenticated, navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #2f3136 0%, #36393f 100%)' }}>
      <div style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
        {status === 'loading' && <p>Joining group...</p>}
        {status === 'success' && <p style={{ color: '#43b581' }}>{message}</p>}
        {status === 'error' && (
          <>
            <p style={{ color: '#f04747' }}>{message}</p>
            <button onClick={() => navigate('/groups')} style={{ marginTop: '16px', padding: '10px 20px', background: '#5865f2', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Go to Groups</button>
          </>
        )}
      </div>
    </div>
  );
};

export default GroupJoinInvite;
